import React from 'react';
import "../../../ui-styles/conference/confResNav.css";

const ConfResOverlay = (props) => {
    return(
        <div className={props.fadeOverlay ? "blackOverlay isVisible" : "blackOverlay"} onClick={props.slideOut}></div>
    )
}
export default ConfResOverlay;